export const API_VERSION = {
  V0: "",
  V1: "/v1",
  V2: "/v2",
};

export const API_HEADER = {
  VERSION: "Version",
  USER_ID: "x-id-user",
  BU_ID: "x-id-bu",
  CORP_ID: "x-id-corp",
  LANGUAGE: "x-lang",
  NTA_NUMBER: "x-nta",
  APP: "x-app",
};
